<div
  class="con-app-navbar app-nav-xs" [hidden]="hidden" [class.disabled]="disabled" >
  <div class="con-app-navbar-container navbar-padding-xs">
    <ul class="con-app-navbar-container-items">
      <li class="con-app-navbar-container-left" *ngIf="!_sharedDataService.isUserSalesConsultant">
        <div id="con-super-menu-icon" *ngIf="currentScreen==='summary'; else backTemplate" class="con-app-navbar-container-item hamburger-menu" [class.hidden]="model?.menu?.hidden">
          <span class="tmi tmi-menu" tabindex="0" id="consupermenuicon" (keyup.enter)="openSuperMenu()"  (click)="openSuperMenu()"></span>
        </div>
        <ng-template #backTemplate class="con-app-navbar-container-item detail-page">
          <span aria-hidden="true" tabindex="0" id="backIcon" (keydown)="_sharedFuncService.keyPress('backIcon')" class="tmi tmi-prev" style="cursor: pointer;" (keyup.enter)="navigateToSummary('tab')" (click)="navigateToSummary('click')"></span>
        </ng-template>
        <div class="con-app-navbar-container-item label" (click)="navigateToSummary('click')">
          <span class="title">Management Console</span>
        </div>
      </li>
      <li #navbarContainerMiddle class="con-app-navbar-container-middle">
        <div class="con-app-navbar-container-item searchbar red">
          <ng-container *ngIf="model?.title?.label === 'Inventory Summary' && toolbarTemplate; else templatecontent">
            <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
          </ng-container>
          <ng-template #templatecontent>
            <ng-content></ng-content>
          </ng-template>
        </div>
      </li>
      <li class="con-app-navbar-container-right">
        <div *ngIf="!_sharedDataService.isUserSalesConsultant" class="con-app-navbar-container-item notification" (click)="model?.notification?.onClick()"></div>  
        <div class="con-app-navbar-container-item notification" *ngIf="_sharedDataService.isUserAuthorized">
          <span  style="margin-right:8px;"  tabindex="0" id="chatIcon" (keydown)="_sharedFuncService.keyPress('chatIcon')" class="tmi tmi-comment" [ngClass]="hasComment? (newMessage? 'chat-icon-highlight pulse':'chat-icon-highlight'):''"   (click)="OpenChat(true)"></span>
          <div *ngIf="chatpanelopen">
          <app-con-app-chat-notification-panel (messageEvent)="OpenChat($event)" ></app-con-app-chat-notification-panel>
        </div>
        </div>
        <div class="indent"></div>
        <div class="con-app-navbar-container-item notification" id="notificationIcon" (keydown)="_sharedFuncService.keyPress('notificationIcon')" tabindex="0" *ngIf="_sharedDataService.isUserAuthorized"
        (click)="model?.notification?.onClick()">
        <span [ngClass]="newNotification? 'noti-icon-highlight pulse':'noti-icon-highlight'" *ngIf="hasNotification" class="tmi tmi-notification hasNotification"></span>
        <span  *ngIf="!hasNotification" class="tmi tmi-nonotification noNotification"></span>
    </div>  
        <div class="indent"></div>
        <span class="tooltip">
        <div id="con-app-navbar-dealer-name"
          class="con-app-navbar-container-item avatar avatar-md padding-10-10 delearnamecolor"
           (keydown)="_sharedFuncService.keyPress('con-app-navbar-dealer-name')" tabindex="0" (click)="model?.avatar?.onClick()"> 
          <span class="tmi tmi-profile custom-clock"></span>
          {{ profileData }}
        </div>
       
        <span class="ptooltiptext">{{_sharedDataService.getDealerNameFromToken()}} <br>{{dealerCode}}</span>
      </span>
      </li>
    </ul>
  </div>
</div>
<div class="profileTemplate-modal" (keyup.escape) ="hideProfileTemplate()" *ngIf="toggleProfileTemplateFlag" (click)="hideProfileTemplate()">
  <div class="profileTemplate-modal-content">
  <div class="dealer-container">
    <div  class="dealername">{{ _sharedDataService.getDealerNameFromToken() }}</div>
    <div class="dealercode">{{ dealerCode }}</div>
</div>
  <div class="con-app-logout" id="con-app-logout-div" tabindex="0" (keyup.enter)="logout()" (click)="logout()">
    <span class="tmi tmi-new-window"></span>
    <div class="item-label">
      Logout
    </div>
  </div>
  </div>
</div>
<div  cdkTrapFocus class="modal1" *ngIf="openunsaveWriteupsDialog" id="unsavedWriteupsDialog" (keyup.escape)="closeSuccessModal('close')">
  <div class="modal-content1">
  <div class="header-content">
  <div class="success-header1" style="border-radius: 8px 8px 0px 0px;">
      Alert!
  </div>
  <div class="approved-message1">
      <span name="success"><em class="fas fa-exclamation"></em></span> 
     <span  class="info-text">  There are unsaved changes. Are you sure you want to continue</span>
  </div>
  </div>
  <div class="footer-buttons1">
    <span  tabindex="0" id="savedChanges-ok" class="ok-button" (keyup.enter)="ContinueUnsaved('ok')" (click)="ContinueUnsaved('ok')" >OK</span>  
    <span tabindex="0"  id="savedChanges-cancel"  class="cancel-button" (keyup.enter)="closeSuccessModal('close')"   (click)="closeSuccessModal('close')">Cancel</span> 
  </div>
</div>
</div>